/* Berry's collection filter UI. */
(function(){
  const MIN_DESKTOP = 1000;
  const OPEN_SORT_GUARD_MS = 650;
  let fullDrawerOpenGuard = null;
  let proxyOpenInProgress = false;

  function getDrawer(){
    const drawers = document.querySelectorAll('#facets-drawer');

    for(const item of drawers){
      if(item.hasAttribute('open')) return item;
    }

    for(const item of drawers){
      if(item.parentElement === document.body) return item;
    }

    return drawers[0] || null;
  }

  function showDrawer(item){
    if(!item || item.hasAttribute('open')) return;

    if(typeof item.show === 'function'){
      item.show();
    }else{
      item.setAttribute('open','');
    }
  }

  /*
   * Impact's established quick-filter trigger opens the drawer through the
   * theme's internal dialog controller. Use that same route for toolbar action
   * buttons, because adding the open attribute alone is not sufficient on every
   * version of the drawer component.
   */
  function openDrawerThroughQuickFilter(item){
    if(!item || item.hasAttribute('open')) return;

    const proxyTrigger = document.querySelector(
      '.berrys-filter-quick .filter-button[data-filter][aria-controls="facets-drawer"]'
    );

    if(proxyTrigger && !proxyOpenInProgress){
      proxyOpenInProgress = true;

      try{
        proxyTrigger.click();
      }finally{
        proxyOpenInProgress = false;
      }

      window.requestAnimationFrame(function(){
        if(!item.hasAttribute('open')) showDrawer(item);
      });

      return;
    }

    showDrawer(item);
  }

  function getCurrentSortValue(item){
    const urlSort = new URL(window.location.href).searchParams.get('sort_by');
    if(urlSort) return urlSort;

    const checked = item?.querySelector('[data-facet-form] input[type="radio"][name="sort_by"]:checked');
    return checked?.value || '';
  }

  function restoreSortValue(item, value){
    if(!item || !value) return;

    item.querySelectorAll('[data-facet-form] input[type="radio"][name="sort_by"]').forEach(function(input){
      input.checked = input.value === value;
    });
  }

  function activateGroup(item, group){
    const form = item?.querySelector('[data-facet-form]');
    if(!form || !group) return;

    form.querySelectorAll('details.vt-accordion.active-filter').forEach(function(details){
      details.classList.remove('active-filter');
    });

    group.classList.add('active-filter');
    group.setAttribute('open','');
    group.setAttribute('aria-expanded','true');
  }

  function makeNonSortGroupActive(item){
    const form = item?.querySelector('[data-facet-form]');
    if(!form) return;

    const currentActive = form.querySelector('details.vt-accordion.active-filter');
    const currentGroup = currentActive?.dataset?.filterGroup || currentActive?.id || '';
    if(currentActive && currentGroup !== 'sort_by' && currentGroup !== 'sort-by') return;

    const safeGroup = Array.from(form.querySelectorAll('details.vt-accordion')).find(function(details){
      const group = details.dataset.filterGroup || details.id || '';
      return group !== 'sort_by' && group !== 'sort-by';
    });

    if(safeGroup) activateGroup(item, safeGroup);
  }

  function startFullDrawerOpenGuard(item){
    const guard = {
      sortValue: getCurrentSortValue(item),
      until: performance.now() + OPEN_SORT_GUARD_MS
    };

    fullDrawerOpenGuard = guard;

    window.setTimeout(function(){
      if(fullDrawerOpenGuard === guard){
        fullDrawerOpenGuard = null;
      }
    }, OPEN_SORT_GUARD_MS + 50);

    return guard;
  }

  function guardIsActive(){
    return fullDrawerOpenGuard && performance.now() <= fullDrawerOpenGuard.until;
  }

  function findGroup(item, key){
    if(!item || !key) return null;

    const form = item.querySelector('[data-facet-form]');
    if(!form) return null;

    const selectors = [];

    if(key === 'sort_by'){
      selectors.push(
        'details.vt-accordion[data-filter-group="sort_by"]',
        'details.vt-accordion[data-filter-group="sort-by"]',
        'details.vt-accordion[id="sort_by"]'
      );
    }

    selectors.push(
      'details.vt-accordion[data-filter-group="' + CSS.escape(key) + '"]',
      'details.vt-accordion[id="' + CSS.escape(key) + '"]'
    );

    for(const selector of selectors){
      const match = form.querySelector(selector);
      if(match) return match;
    }

    return null;
  }

  function enhanceDrawer(item = getDrawer()){
    if(!item || window.innerWidth < MIN_DESKTOP) return;

    const heading = item.querySelector('[slot="header"]');
    if(heading) heading.textContent = 'Filters';

    item.querySelectorAll('details.vt-accordion').forEach(function(details){
      details.open = true;
      details.setAttribute('aria-expanded','true');
    });

    const footer = item.querySelector('.facets-drawer__floating-apply');
    const applyButton = footer?.querySelector('button[is="facet-apply-button"]');

    if(footer && applyButton){
      const count = applyButton.querySelector('[data-facet-filter-count]')?.textContent?.trim() || '';
      applyButton.dataset.facetApplyLabel = 'VIEW ALL';
      applyButton.textContent = count ? 'VIEW ALL ' + count : 'VIEW ALL';

      let clearLink = footer.querySelector('.berrys-drawer-clear');

      if(!clearLink){
        clearLink = document.createElement('a');
        clearLink.className = 'berrys-drawer-clear';
        clearLink.href = window.location.pathname;
        clearLink.setAttribute('is','facet-link');
        clearLink.setAttribute('data-no-instant','');
        footer.insertBefore(clearLink, applyButton);
      }

      if(document.querySelector('.shopify-section--main-search')){
        const clearUrl = new URL(window.location.href);
        Array.from(clearUrl.searchParams.keys()).forEach(function(key){
          if(key.startsWith('filter.') || key === 'page' || key === 'section_id'){
            clearUrl.searchParams.delete(key);
          }
        });
        clearLink.href = clearUrl.pathname + clearUrl.search;
      }

      clearLink.textContent = 'CLEAR';
    }
  }

  /* Capture the selected sort value before the full drawer starts opening. */
  window.addEventListener('pointerdown', function(event){
    if(window.innerWidth < MIN_DESKTOP) return;

    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-open-filter-drawer]');
    if(!trigger) return;

    startFullDrawerOpenGuard(getDrawer());
  }, true);

  /* Prevent legacy initialisation from changing Sort while the full drawer opens. */
  window.addEventListener('change', function(event){
    if(!guardIsActive()) return;

    const input = event.target;
    if(!(input instanceof HTMLInputElement)) return;
    if(input.type !== 'radio' || input.name !== 'sort_by') return;
    if(!input.closest('#facets-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    restoreSortValue(getDrawer(), fullDrawerOpenGuard.sortValue);
  }, true);

  /* MORE FILTERS opens the complete permitted drawer without changing Sort. */
  window.addEventListener('click', function(event){
    if(window.innerWidth < MIN_DESKTOP) return;

    const target = event.target instanceof Element ? event.target : null;
    const fullDrawerTrigger = target?.closest('[data-open-filter-drawer]');
    if(!fullDrawerTrigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const item = getDrawer();
    if(!item) return;

    const guard = guardIsActive() ? fullDrawerOpenGuard : startFullDrawerOpenGuard(item);

    restoreSortValue(item, guard.sortValue);
    makeNonSortGroupActive(item);
    openDrawerThroughQuickFilter(item);
    fullDrawerTrigger.setAttribute('aria-expanded','true');

    window.requestAnimationFrame(function(){
      restoreSortValue(item, guard.sortValue);
      makeNonSortGroupActive(item);
      enhanceDrawer(item);
    });

    window.setTimeout(function(){
      restoreSortValue(item, guard.sortValue);
      makeNonSortGroupActive(item);
      enhanceDrawer(item);

      const body = item.shadowRoot?.querySelector('[part="body"]');
      if(body) body.scrollTop = 0;
    }, 100);

    window.setTimeout(function(){
      restoreSortValue(item, guard.sortValue);
    }, 250);
  }, true);

  /* Quick filters and Sort open the same drawer at the relevant group. */
  document.addEventListener('click', function(event){
    if(window.innerWidth < MIN_DESKTOP) return;

    const eventTarget = event.target instanceof Element ? event.target : null;
    const trigger = eventTarget?.closest('.berrys-filter-bar [aria-controls="facets-drawer"]');
    if(!trigger || trigger.hasAttribute('data-open-filter-drawer')) return;

    const item = getDrawer();
    if(!item) return;

    const isToolbarAction = trigger.closest('.berrys-filter-actions') !== null;

    if(!trigger.hasAttribute('data-search-filter-open')){
      if(isToolbarAction && !proxyOpenInProgress){
        openDrawerThroughQuickFilter(item);
      }else{
        showDrawer(item);
      }
    }

    window.setTimeout(function(){
      enhanceDrawer(item);

      const filterKey = trigger.getAttribute('data-filter');
      if(!filterKey) return;

      const targetGroup = findGroup(item, filterKey);

      if(targetGroup){
        activateGroup(item, targetGroup);
        targetGroup.scrollIntoView({behavior:'smooth', block:'start'});
      }
    }, 100);
  }, true);

  function updateSearchResults(control, updateUrl){
    const section = control.closest('.shopify-section--main-search');
    if(!section) return;

    const url = new URL(window.location.href);
    updateUrl(url);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
    control.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: {url: url}
    }));
  }

  document.addEventListener('change', function(event){
    const target = event.target instanceof Element ? event.target : null;
    const select = target?.closest('.shopify-section--main-search [data-berrys-category-sort]');
    if(!select) return;

    updateSearchResults(select, function(url){
      url.searchParams.set('sort_by', select.value);
    });
  });

  document.addEventListener('click', function(event){
    const target = event.target instanceof Element ? event.target : null;
    const stock = target?.closest('.shopify-section--main-search [data-search-stock]');
    if(!stock || stock.disabled) return;

    event.preventDefault();
    updateSearchResults(stock, function(url){
      const name = stock.dataset.stockName;
      const value = stock.dataset.stockValue;
      const active = url.searchParams.getAll(name).includes(value);
      url.searchParams.delete(name);
      if(!active) url.searchParams.set(name, value);
    });
  });

  document.addEventListener('change', function(event){
    const eventTarget = event.target instanceof Element ? event.target : null;

    if(window.innerWidth >= MIN_DESKTOP && eventTarget?.closest('#facets-drawer [data-facet-form]')){
      window.requestAnimationFrame(function(){ enhanceDrawer(); });
    }
  }, true);

  document.addEventListener('dialog:after-show', function(event){
    const eventTarget = event.target instanceof Element ? event.target : null;

    if(eventTarget?.id === 'facets-drawer' || eventTarget?.closest('#facets-drawer')){
      if(guardIsActive()){
        restoreSortValue(getDrawer(), fullDrawerOpenGuard.sortValue);
        makeNonSortGroupActive(getDrawer());
      }

      enhanceDrawer();
    }
  });

  document.addEventListener('dialog:after-hide', function(event){
    const eventTarget = event.target instanceof Element ? event.target : null;

    if(eventTarget?.id === 'facets-drawer' || eventTarget?.closest('#facets-drawer')){
      document.querySelectorAll('[data-open-filter-drawer]').forEach(function(button){
        button.setAttribute('aria-expanded','false');
      });
    }
  });

  document.addEventListener('facet:updated', function(){
    window.requestAnimationFrame(function(){ enhanceDrawer(); });
  });

  document.addEventListener('shopify:section:load', function(){
    enhanceDrawer();
  });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ enhanceDrawer(); });
  }else{
    enhanceDrawer();
  }
})();


(function(){
  if(!document.body.classList.contains('temlate-search')) return;
  let queued=false;
  const expandedGroups=new Map();
  function enhance(){
    queued=false;
    document.querySelectorAll('.boost-sd__filter-tree-vertical--sticky').forEach(function(drawer){
      if(!drawer.querySelector('.berrys-boost-heading')){
        const heading=document.createElement('h2');
        heading.className='berrys-boost-heading';
        heading.textContent='Filter & Refine';
        drawer.prepend(heading);
      }
      
      drawer.querySelectorAll('.boost-sd__filter-option-listitem').forEach(function(list){
        const group=list.closest('[data-filteroptionid]');
        if(!group)return;
        const key=group.getAttribute('data-filteroptionid');
        const items=Array.from(list.children);
        let toggle=list.parentElement.querySelector('.berrys-boost-more');
        if(items.length<=7){
          list.classList.remove('berrys-boost-list-collapsed');
          if(toggle)toggle.remove();
          return;
        }
        if(!toggle){
          toggle=document.createElement('button');
          toggle.type='button';
          toggle.className='berrys-boost-more';
          toggle.addEventListener('click',function(){
            expandedGroups.set(key,!expandedGroups.get(key));
            enhance();
          });
          list.after(toggle);
        }
        const expanded=expandedGroups.get(key)===true;
        list.classList.toggle('berrys-boost-list-collapsed',!expanded);
        const text=expanded?'View less':'View more';
        if(toggle.textContent!==text)toggle.textContent=text;
        toggle.setAttribute('aria-expanded',String(expanded));
        const name=group.querySelector('.boost-sd__filter-option-title')?.textContent.trim()||'filter';
        toggle.setAttribute('aria-label',text+' '+name+' options');
        if(list.id)toggle.setAttribute('aria-controls',list.id);
      });

      const heading=drawer.querySelector('.berrys-boost-heading');
      const nativeClear=document.querySelector('#boost-sd__button--clear-all-filters');
      let mobileClear=heading.querySelector('.berrys-boost-clear');
      if(nativeClear && !mobileClear){
        mobileClear=document.createElement('button');
        mobileClear.type='button';
        mobileClear.className='berrys-boost-clear';
        mobileClear.textContent='Clear all';
        mobileClear.addEventListener('click',function(){
          document.querySelector('#boost-sd__button--clear-all-filters')?.click();
        });
        heading.append(mobileClear);
      }else if(!nativeClear && mobileClear){mobileClear.remove();}
      const button=drawer.querySelector('button.boost-sd__button--result');
      if(button){
        const label=button.querySelector('.boost-sd__button-text')||button;
        const count=label.textContent.match(/[\d,]+/);
        if(count){
          const text='VIEW '+count[0]+' RESULTS';
          if(label.textContent!==text) label.textContent=text;
          if(button.getAttribute('aria-label')!==text)button.setAttribute('aria-label',text);
        }
      }
      const clear=drawer.querySelector('#boost-sd__button--clear-all-filters');
      const clearLabel=clear?.querySelector('.boost-sd__button-text')||clear;
      if(clearLabel && clearLabel.textContent.trim()!=='Clear all')clearLabel.textContent='Clear all';
    });
  }
  const observer=new MutationObserver(function(){
    if(!queued){queued=true;requestAnimationFrame(enhance);}
  });
  observer.observe(document.getElementById('main')||document.body,{childList:true,subtree:true,characterData:true});
  enhance();
})();
